import { Entity } from '@inter-ikea-core/core';
import { ProductType } from '@inter-ikea-storageone/range';
import { reportTVStatus } from 'analytics/reporters';
import { useCore } from 'contexts/core';
import { getProductEntities } from 'ducks/core';
import { useAppDispatch } from 'ducks/hooks';
import { addTV } from './behaviors/addTV';
import React, { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import SceneAction from '../../../../components/SceneMenu/SceneAction';
import { store } from 'ducks';
import { TvIcon } from '../../../../components/SceneMenu/icons/TV';
import {
  getTvPlacement,
  getTvSize,
  showAddTVSheet,
  tvBenchProductTypes,
  TvPlacement
} from './TVFeature';
import { getMarketProducts } from 'ducks/products';
import { getRange } from 'utils/queryUtils';

export const Test = () => <div>HEJ</div>;

const TVAction = (props: React.PropsWithoutRef<JSX.IntrinsicElements['button']>) => {
  const { formatMessage } = useIntl();
  const dispatch = useAppDispatch();
  const productEntites = useSelector(getProductEntities);
  const productsInMarket = useSelector(getMarketProducts);
  const rootState = store.getState();
  const tvSize = useSelector(getTvSize);
  const tvPlacement = useSelector(getTvPlacement);
  const coreApi = useCore();
  const [tvsInScene, setTvsInScene] = useState<Entity[]>([]);
  const tvBench = coreApi.entities.getByProductTypes(tvBenchProductTypes);

  const tvFrameInMarket =
    productsInMarket.filter(p => tvBenchProductTypes.includes(p.type)).length > 0;

  useEffect(() => {
    const tvs = coreApi.entities.getByProductTypes([ProductType.TV, ProductType.TV_WITH_FOOT]);
    tvs[0]?.id !== tvsInScene[0]?.id && setTvsInScene(tvs);
  }, [coreApi.entities, productEntites, tvsInScene]);

  const toggleTv = () => {
    if (tvsInScene.length > 0) {
      coreApi.entities.deleteMultiple(tvsInScene);
      reportTVStatus({ enable: false });
    } else {
      if (tvSize === undefined) {
        dispatch(showAddTVSheet());
      } else {
        const placement = tvBench.length > 0 ? tvPlacement : TvPlacement.wall;
        addTV({
          dispatch,
          coreApi,
          props: { tvSize, tvPlacement: placement },
          rootState
        });
        reportTVStatus({ enable: true });
      }
    }
  };

  return getRange() === 'eket' && !tvFrameInMarket ? (
    <></>
  ) : (
    <SceneAction
      {...props}
      label={
        tvsInScene.length > 0
          ? formatMessage({ id: 'storageone.sceneMenuRemoveTv' })
          : formatMessage({ id: 'storageone.sceneMenuAddTv' })
      }
      dataTestId="scene-tv-action"
      onClick={toggleTv}
      ssrIcon={TvIcon as any}
      enabled={tvsInScene.length > 0}
    />
  );
};

export default TVAction;
